import styled from 'styled-components'

export const ErrorMessage = styled.p`
  background: #fff2f0;
  border-radius: 6px;
  border: 1px solid #F44336;
  color: #d21608;
  font-size: .9rem;
  font-weight: 400;
  padding: 8px;
  margin: 12px 0;
`;